module.exports = __webpack_public_path__ + "img/Endya.f68977a4.png";